// extracted by mini-css-extract-plugin
export var articleHeader = "template-module--article-header--f9664";
export var authorContainer = "template-module--author-container--ec68f";
export var blogContainer = "template-module--blog-container--3b79f";
export var blogPostCardImage = "template-module--blog-post-card-image--3cabe";
export var darkGrey = "template-module--dark-grey--dbf89";
export var divider = "template-module--divider--329d6";
export var footerAvatar = "template-module--footer-avatar--ee2c3";
export var group = "template-module--group--d91c9";
export var markdownContent = "template-module--markdown-content--37f8e";
export var paginationContainer = "template-module--pagination-container--d6046";
export var scale = "template-module--scale--1f43c";
export var section = "template-module--section--f61d1";
export var stickyTop = "template-module--sticky-top--4188a";
export var tableOfContentsAside = "template-module--table-of-contents-aside--dc82a";
export var tableOfContentsItem = "template-module--table-of-contents-item--e0871";